import { createElement } from './PluginCustomProgress';

const PluginLoading = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function() {
        this.loading = null;
        this.el = null;
        this.player = null;
        this.bindWaiting = this.waiting.bind(this);
        this.bindCanPlay = this.canplay.bind(this);
      },
      createEl: function(el: any, player: any) {
        this.el = el;
        this.player = player;

        this.loading = createElement('div', {
          className: 'center prism-hide'
        });
        this.loading.appendChild(
          createElement('div', {
            className: 'circle'
          })
        );
        this.loading.appendChild(
          createElement('div', {
            className: 'circle1'
          })
        );

        this.el.appendChild(this.loading);

        this.player.on('waiting', this.bindWaiting);
        this.player.on('canplay', this.bindCanPlay);
      },
      waiting: function() {
        this.loading.className = 'center prism-loading';
      },
      canplay: function() {
        this.loading.className = 'center prism-hide';
      }
    })
  : null;

export default PluginLoading;
